import React from "react"
import { Link, navigate } from "gatsby"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import {
  Button,
  IconButton,
  CssBaseline,
  Container,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useScrollTrigger,
  SwipeableDrawer,
  Collapse,
  Grid,
} from "@material-ui/core"
import MenuIcon from "@material-ui/icons/Menu"
import PublicIcon from "@material-ui/icons/Public"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import CloseIcon from "@material-ui/icons/Close"
import "./layout.css"
// import StaticPages from "../components/static_pages";
import image from "../../static/media/Images/logo.svg"
import bluelogo from "../../static/media/Images/logo-blue.svg"
import Preloader from "../../static/preloader-500.png"

const windowGlobal = typeof window !== "undefined" && window

if (windowGlobal) {
  if (windowGlobal.matchMedia("(display-mode: standalone)").matches || windowGlobal.matchMedia("(display-mode: fullscreen)").matches) {
    document.getElementsByClassName("preloader").className = "preloaderHide"
    console.log("This is running as standalone.")
  }
}

const useStyles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  hdrSearchForms: {
    marginTop: 7,
    marginBottom: 7,
    "& .MuiInputBase-input": {
      backgroundColor: "#005979",
      fontSize: "1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: ".8rem",
      },

      color: "#fff",
      fontFamily: '"uthman"',
      paddingTop: 15,
      paddingBottom: 15,
      borderRadius: 10,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "0",
    },
    "& .MuiSelect-iconOutlined": {
      color: "#fff",
    },
    "& .MuiSelect-select:not([multiple]) option:first-child": {},
  },
  readerFormControl: {
    width: "100%",
    margin: "0px auto",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    display: "inherit",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  fabButton: {
    position: "absolute",
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: "0 auto",
  },
  grow: {
    flexGrow: 1,
  },
  DialogCntnt: {
    width: 500,
    maxWidth: "90%",
    margin: "auto",
  },
  tblPgntn: {
    position: "absolute",
    top: "auto",
    bottom: 0,
    margin: "auto",
    float: "right",
  },
  svgImg: {
    marginRight: 15,
    width: 40,
    height: "auto",
    borderRadius: 5,
  },
  /* new Editions End */
  icon: {
    marginRight: theme.spacing(2),
  },
  appBar: {
    "&.MuiPaper-elevation0 .MuiToolbar-root": {
      borderRadius: "4px",
      backgroundColor: "rgb(255, 255, 255, 0/*.85*/)",
      margin: "10px 10px 0px",
      transition: "all .5s",
      "& .MuiIconButton-root": {
        color: "#fff",
      },
    },
    "&.MuiPaper-elevation4 .MuiToolbar-root": {
      borderRadius: "4px",
      backgroundColor: "rgb(255, 255, 255)",
      margin: "10px 10px 0px",
      transition: "all .5s",
      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    },
    "&.MuiPaper-elevation4": {
      boxShadow: "none",
    },
  },
  toolBar: {},
  heroContent: {
    "& .MuiContainer-root": {
      position: "relative",
      zIndex: 3,
    },
    "& .MuiTypography-root": {
      color: "#fff",
    },
    "& .MuiTypography-h2": {
      fontSize: "3em",
    },
    marginTop: "0em",
    backgroundImage: "radial-gradient(circle farthest-side,#00b1d5 2%, #005b7b 70%)",
    backgroundSize: "contain",
    paddingTop: "1em",
    position: "relative",
    paddingBottom: ".8em",
  },
  drawerTextLogo: {
    color: "red",
    fontWeight: 900,
    fontSize: 26,
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  drawerTextLogo2: {
    color: "green",
    fontWeight: 900,
    fontSize: 26,
  },
  drawerSubtitle: {
    paddingTop: 10,
    paddingLeft: "16px",
    paddingRight: "16px",
    textAlign: "center",
  },
  drawerHr: {
    width: "80%",
    margin: "0 auto",
    marginBottom: "calc(1.45rem - 1px)",
  },
  drawerPaper: {
    width: 300,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  svgImgMenu: {
    marginBottom: 0,
    marginRight: 0,
    width: 40,
    height: "auto",
    borderRadius: 5,
  },
  dialogClsBtn: {
    position: "absolute",
    right: 0,
    top: 7,
  },
  rtl: {
    direction: "rtl",
    "& .MuiListItem-button": {
      textAlign: "right",
    },
    "& .MuiListItem-dense": {
      paddingLeft: "initial",
      paddingRight: theme.spacing(4),
    },
    "& .MuiSelect-iconOutlined": {
      right: "initial",
      left: 7,
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight: 10,
      paddingLeft: 10,
    },
    "&.MuiDialogActions-root": {
      right: "initial",
      left: 0,
    },
  },
  langDrwerIcon: {
    minWidth: 40,
  },

  appBarIcons: {
    color: "white",
  },

  preloaderTextLogo: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },

  breadcrumpsSearchForms: {
    backgroundColor: "#f4f4f4",
    borderRadius: 10,
    "& .MuiBreadcrumbs-ol": {
      color: "green",
      justifyContent: "center",
    },
  },
  headerLogo: {
    "& img": {
      width: "14em",
    },
  },
  headerLogoGrid: {
    textAlign: "center",
  },
  preloader: {
    backgroundImage: "radial-gradient(circle farthest-side,#00b1d5 2%, #005b7b 70%)",
  },
})

function ElevationScroll(props) {
  const { children } = props
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
}

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.handleClickOpenDialog = this.handleClickOpenDialog.bind(this)
    this.handleCloseDialog = this.handleCloseDialog.bind(this)
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this)
    this.handleCityClick = this.handleCityClick.bind(this)
    this.state = {
      OpenSearch: false,
      drawerOpen: false,
      CllapseLangOpen: false,
    }
  }

  handleLangChange(lang, e) {
    this.props.onLangChange2(lang, e)
  }

  handleClickOpenDialog() {
    this.setState({
      OpenSearch: true,
    })
  }

  handleCloseDialog() {
    this.setState({
      OpenSearch: false,
    })
  }

  handleDrawerToggle() {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    })
  }

  handleCityClick() {
    this.setState({
      CllapseLangOpen: !this.state.CllapseLangOpen,
    })
  }

  handlePagesChange(event) {
    // if (newValue)
    navigate("/p/" + event.target.value)
  }

  handlePartsChange(event) {
    navigate("/pr/" + event.target.value)
  }

  handleSurahsChange(event) {
    navigate("/s/" + event.target.value)
  }

  surahsNames(data) {
    const allSurahs = []
    for (const surah of data.allStrapiSurahs.nodes) {
      let mlText = surah.name.filter(x => x.lang.lang === this.props.lang)[0]
      if (mlText) {
        mlText = mlText.text
      } else {
        mlText = this.props.locale["Surah"][this.props.lang] + " " + surah.surah_number
      }
      allSurahs.push({
        title: mlText,
        number: surah.surah_number,
      })
    }
    return allSurahs
  }

  render() {
    const lang = this.props.lang
    const locale = this.props.locale
    const dataNew = this.props.dataNew
    const allPages = []
    for (let i = 1; i <= 604; i++) {
      allPages[i] = { identifier: locale["Page"][lang], number: i }
    }

    const allParts = []
    for (let i = 1; i <= 30; i++) {
      allParts[i] = { identifier: locale["Part"][lang], number: i }
    }

    const { classes } = this.props

    function ListItemLink(props) {
      const { icon, primary, to } = props

      const renderLink = React.useMemo(() => React.forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />), [to])

      return (
        <ListItem button component={renderLink} divider>
          {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
          <ListItemText className={classes.drawerListItem} primary={primary} />
        </ListItem>
      )
    }

    ListItemLink.propTypes = {
      icon: PropTypes.element,
      primary: PropTypes.string.isRequired,
      to: PropTypes.string /*.isRequired*/,
    }

    const direction = lang === "ar" ? "rtl" : "ltr"

    const drawer = (
      <div className={`${classes[direction]} ${classes.drawerPaper}`}>
        <List className={classes.menuList}>
          <Button onClick={this.handleDrawerToggle} color="primary">
            <CloseIcon />
          </Button>
          <br />
          <div className="drwrlogo">
            <Link to="/">
              <img src={bluelogo} alt="logo" />
            </Link>
          </div>
          <p className={classes.drawerSubtitle}>
            {locale["Hello every one"][lang]}
            <br />
            {locale["welcome you"][lang]}
          </p>
          <hr className={classes.drawerHr} />
          <ListItemLink to="/" primary={locale["Home"][lang]} />
          <ListItemLink to="/downloads" primary={locale["downloads"][lang]} />
          {/* <StaticPages locale={locale} lang={lang} /> */}

          <ListItem button onClick={this.handleCityClick} divider>
            <ListItemIcon className={classes.langDrwerIcon}>
              <PublicIcon />
            </ListItemIcon>
            <ListItemText primary={locale["Languages"][lang]} />
            {this.state.CllapseLangOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={this.state.CllapseLangOpen} timeout="auto" unmountOnExit>
            <List dense={true} component="div" disablePadding>
              {/* {console.log(dataNew),
              console.log(locale),
              console.log(lang)
              } */}
              {dataNew &&
                Object.keys(dataNew).map(key =>
                  (dataNew[key]?.lang?.lang_name && dataNew[key]?.publicURL) || dataNew[key]?.lang?.flag?.publicURL ? (
                    <ListItem button onClick={e => this.handleLangChange(key, e)} key={key} className={classes.nested}>
                      <ListItemIcon>
                        {dataNew[key].publicURL ? (
                          <img className={classes.svgImgMenu} src={dataNew[key].publicURL} alt={key} />
                        ) : (
                          <img className={classes.svgImgMenu} src={dataNew[key].lang.flag.publicURL} alt={dataNew[key].lang.lang_name} />
                        )}
                      </ListItemIcon>
                      <ListItemText primary={dataNew[key].lang.lang_name}></ListItemText>
                    </ListItem>
                  ) : null
                )}
            </List>
          </Collapse>
        </List>
      </div>
    )

    let loader = ""
    if (windowGlobal) {
      if (windowGlobal.sessionStorage.getItem("loaded")) {
        loader = "none"
      } else {
        loader = "block"
        windowGlobal.sessionStorage.setItem("loaded", true)
      }
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={`${classes.preloader} preloader`} style={{ display: loader }}>
          <img className={`${classes.drawerTextLogo} ${classes.preloaderTextLogo}`} src={Preloader} alt="Preloader" />
        </div>
        <Container maxWidth={false} className={classes.heroContent}>
          <Grid justifyContent="center" alignContent="center" alignItems="center" container>
            <Grid md={1} xs={1} item>
              <IconButton onClick={this.handleDrawerToggle} className={classes.appBarIcons} aria-label="open">
                <MenuIcon />
              </IconButton>
              <SwipeableDrawer
                variant="temporary"
                anchor="left"
                open={this.state.drawerOpen}
                onOpen={this.handleDrawerToggle}
                onClose={this.handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {drawer}
              </SwipeableDrawer>
            </Grid>
            <Grid md={10} xs={10} item className={classes.headerLogoGrid}>
              <div className={classes.headerLogo}>
                <Link to="/">
                  <img src={image} alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid md={1} xs={1} item />
          </Grid>
        </Container>
      </React.Fragment>
    )
  }
}

export default withStyles(useStyles)(Header)
